/**
 * Indicates the function the trigger of the navigation
 * Set as info on NavigationBehaviorOptions
 */
export enum NavigationSource {
    /**
     * Navigation was triggered by a side nav item=
     */
    Sidenav = "SIDENAV",

    /**
     * Navigation was triggered by a router service call
     */
    RouterService = "ROUTER_SERVICE",

    /**
     * Navigation was triggered by a breadcrumb click
     */
    Breadcrumb = "BREADCRUMB",

    /**
     * Navigation was trigged by a Guard
     */
    Guard = "GUARD",

    /**
     * Navigation was triggered by a Resolver
     */
    Resolver = "RESOLVER",

    /**
     * Navigation as triggered by a redirect function
     */
    RedirectFunction = "REDIRECT_FUNCTION",

    /**
     * Navigation was triggered by an error
     *
     * All Guards should respect this nav type and allow navigation away from the current route
     */
    Error = "ERROR",
}
